export default "__VITE_ASSET__B6wcl4L9__"